import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbMetaTrader4 = () => {
  return (
    <div
      className="ht__bradcaump__area__platform"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>MetaTrader 4 (MT4)</h1>
              <p>
                The world’s most trusted trading platform, now powered by The
                Pips for precision, performance, and control.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Download Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbMetaTrader4.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbMetaTrader4;
